import { render, staticRenderFns } from "./magazine-call-to-action-panel.vue?vue&type=template&id=6b6c6c6d&"
var script = {}
import style0 from "./magazine-call-to-action-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports